import React from 'react';
import classNames from 'classnames';
import Skeleton from 'react-loading-skeleton';

import styles from './WindStationCardPlaceholder.module.scss';

const getClass = (loading?: boolean, largeOnly?: boolean, rootClass?: string) =>
  classNames(
    'sl-wind-station-placeholder',
    {
      [styles.placeholder]: true,
      [styles.placeholderLoading]: loading,
      [styles.placeholderLargeOnly]: largeOnly,
    },
    rootClass,
  );

interface Props {
  loading?: boolean;
  largeOnly?: boolean;
  classes?: { root?: string };
}

const WindStationCardPlaceholder: React.FC<Props> = ({
  loading,
  largeOnly = false,
  classes = {},
}) => (
  <div className={getClass(loading, largeOnly, classes.root)}>
    {loading && <Skeleton className={styles.skeleton} />}
  </div>
);

export default WindStationCardPlaceholder;
